import Swiper, { Navigation } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/swiper-bundle.css';

function PopUpSlider() {
  const goSlideBtns = document.querySelectorAll('.goToSlide');

  const ProSwiper = () => {
    const swiper = new Swiper('.swiper', {
      modules: [Navigation],
      speed: 400,
      spaceBetween: 100,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: true,
      breakpoints: {
        600: {
          direction: 'vertical',
        },
      },
    });

    goSlideBtns.forEach((el) =>
      el.addEventListener('click', function () {
        swiper.slideTo(el.dataset.index - 1);
      })
    );
  };

  const init = () => {
    ProSwiper();
  };

  init();
}

export default PopUpSlider;
